import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import NoData from '../page/NoData';
import ClosedReturnsSummaryLine from './ClosedReturnsSummaryLine';

import Logger, {LOG_LEVELS} from '../../utils/logger';
const log = new Logger('CLOSED_RETURNS_ROW', LOG_LEVELS.DEBUG);

class ClosedReturnRows extends Component {

render() {
    log.debug('render(): ', this.props);
    const data = this.props.data || [];

    if (data.length < 1 ) {
      return (<div>
        <NoData
          noDataText="closedReturns_NoData"
        />
      </div>)
    }

    return (
      <div>
        <table className="updated-card-table">
          <thead>
          <tr>
            <th><LanguageStringResolver string='reportType'/></th>
            <th><LanguageStringResolver string='startDate'/></th>
            <th><LanguageStringResolver string='endDate'/></th>
            <th><LanguageStringResolver string='company'/></th>
            <th><LanguageStringResolver string='actions'/></th>
          </tr>
          </thead>
          <tbody>

          {/* Iterate through the data using a row component for each row */}
          {data.map((row, key) =>
            <ClosedReturnsSummaryLine
              key={key}
              rowDetail={row}
              clickReopen={this.props.onReopenClick}
              filterSelection={this.props.filterSelection}
            />
          )}
          </tbody>
        </table>
        <hr />
      </div>
    )
  }
}


ClosedReturnRows.defaultProps = {
  data: [],
  mainCompany: { name: 'unknown'},
  onReopenClick: () => {},
  filterSelection: {}
};

function mapStateToProps(state) {
  log.debug('mapStateToProps(): ', state);
  return {};
}

export default connect(mapStateToProps)(ClosedReturnRows);